import './contacts.css';
import phone from '../../../assets/images/phone-icon.svg'
import address from '../../../assets/images/address-icon.svg'
import email from '../../../assets/images/email-icon.svg'

const icons = {phone, address, email};

function renderText(nick, text, clearedtext) {

        switch (nick) {

            case 'phone': return  <a href={`tel: ${clearedtext}`}>{text}</a>
            case 'email': return  <a href={`mailto: ${text}`}>{text}</a>
            default: return text

        }
}


function Contact({nick, title, text, clearedtext}) {

    return (
        <div className="item">
            <div className="icon"><img src={icons[nick]} /></div>
            <div className="title">{title}</div>
            <div className="text">{renderText(nick, text, clearedtext)}</div>
        </div>
    )
}

export default Contact;